import React, { useEffect, useCallback, useState } from 'react';
import { Row, Col, Button, Form, DatePicker } from 'antd';
import moment from 'moment';

const DateType = ({ question, onEdit, onChange }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [form] = Form.useForm();

  const getInitialMoment = (value) => {
    if (!value || value.trim() === '') return null;
    return moment(value, 'YYYY-MM-DD', true).isValid() ? moment(value, 'YYYY-MM-DD') : null;
  };

  const onFinish = (values) => {
    const dateValue = values.date;
    const answerToSave = dateValue ? dateValue.format('YYYY-MM-DD') : '';
    onChange(question.testId, question.groupId, question.questionId, answerToSave);
    form.resetFields();
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onEdit(question.questionId, date ? date.format('YYYY-MM-DD') : '');
    form.setFieldsValue({ date });
  };

  useEffect(() => {
    form.resetFields();
    const initialMoment = getInitialMoment(question.selectedAnswer);
    form.setFieldsValue({ date: initialMoment });
    setSelectedDate(initialMoment);
  }, [question.selectedAnswer, form]);

  return (
    <Row justify="center">
      <Form
        onFinish={onFinish}
        form={form}
        initialValues={{ date: getInitialMoment(question.selectedAnswer) }}
        style={{ width: '100%' }}
      >
        <Col md={24}>
          <Row justify="center">
            <Col md={24} className="options-wrapper p-40 mt-40 mb-80">
              <Row justify="center">
                <Col md={24}>
                  <h2
                    className="text-center mt-10 mb-50"
                    dangerouslySetInnerHTML={{ __html: question.questionTitle && question.questionTitle }}
                  />
                </Col>
                <Col md={10}>
                  <Form.Item name="date" className="mb-0">
                    <DatePicker
                      style={{ width: '100%', fontSize: '22px' }}
                      size="large"
                      format="YYYY-MM-DD"
                      placeholder={question.questionTitle && question.questionTitle}
                      onChange={handleDateChange}
                      value={selectedDate}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          {
            question && !question.isChecking &&
            <Row justify="end" className="mb-40">
              <Col md={6}>
                <Button
                  disabled={!selectedDate}
                  className={!selectedDate ? 'button-disabled' : ''}
                  type="primary"
                  size="large"
                  htmlType="submit"
                  block
                >
                  Confirmar cambio
                </Button>
              </Col>
            </Row>
          }
        </Col>
      </Form>
    </Row>
  );
};

export default DateType;
